import { ApiService } from '@b2b/common/services/api/types';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ColumnDef, TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';
import { InventoryItem } from '../../../../inventory/list/types';

TemplatesCreateAddonsController.$inject = [
  '$scope',
  '$timeout',
  'ApiService',
  'TemplatesService',
  'HelpersService',
  'ThemesHelperService',
];

function TemplatesCreateAddonsController(
  $scope: IScope & { templatesCreateAddons: TODO; addOnGridOptions: TODO },
  $timeout: ITimeoutService,
  ApiService: ApiService,
  TemplatesService: TODO,
  HelpersService: TODO,
  ThemesHelperService: ThemesHelperService
) {
  $scope.addOnGridOptions = {
    enableRowSelection: false,
    multiSelect: false,
    paginate: false,
    columnDefs: [
      {
        field: 'id',
        visible: false,
      },
      {
        field: 'order',
        visible: false,
      },
      {
        field: 'name',
        displayName: 'Name',
      },
      {
        field: 'description',
        displayName: 'Description',
      },
      {
        field: 'sku',
        displayName: 'SKU',
      },
      {
        field: 'printTicket',
        displayName: 'Print Ticket',
        cellTemplate: `<div class="ui-grid-cell-contents">{{ (MODEL_COL_FIELD) ? "Yes" : "No" }}</div>`,
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        type: 'boolean',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Add-on {{ row.entity.name }} Web</span></label></div>`,
      },
      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        type: 'boolean',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Add-on {{ row.entity.name }} POS</span></label></div>`,
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        type: 'boolean',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Add-on {{ row.entity.name }} Reseller</span></label></div>`,
      },
      {
        field: 'salesChannels[3].enabled',
        displayName: 'Customer Rep.',
        type: 'boolean',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Add-on {{ row.entity.name }} Customer Rep.</span></label></div>`,
      },
      {
        field: 'salesChannels[5].enabled',
        displayName: 'Kiosk',
        type: 'boolean',
        cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Add-on {{ row.entity.name }} Customer Rep.</span></label></div>`,
      },
      {
        field: 'actions',
        displayName: 'Actions',
        onCellNavClick: (row, col) => {
          ctrl.removeInventory(row.entity.id);
        },
        cellTemplate: `<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>`,
      },
    ] as ColumnDef[],
  };

  const ctrl = {
    enableSalesTax: false,
    model: [] as InventoryItem[],
    inventory: [] as InventoryItem[],
    selectedInventory: {} as Partial<InventoryItem>,
    currentAddOns: [] as TODO[],

    init: function () {
      ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');

      if (ctrl.enableSalesTax) {
        const priceColumnIndex = $scope.addOnGridOptions.columnDefs.findIndex((column) => column.field === 'price');

        /**
         * Insert after `basePrice` after `price` column
         */
        $scope.addOnGridOptions.columnDefs.splice(priceColumnIndex + 1, 0, {
          field: 'basePrice',
          displayName: 'Base Price',
          cellFilter: 'basePrice',
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        });
      }

      ctrl.model = TemplatesService.getAddOns();
      ctrl.processSalesChannels();
      $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
      $scope.$on('TemplatesCreateController::Save', ctrl.onTemplatesCreateControllerSave);
      console.log('TemplatesCreateAddonsController::init');

      ctrl.getInventory();

      TemplatesService.setIsTabLoading(false, 'addons');
    },

    hasAddOns: function () {
      return Array.isArray(ctrl.model) && ctrl.model.length > 0;
    },

    getInventory: function () {
      ApiService.inventory
        .list(angular.extend({ addonTypes: 'doNotTrack' }, HelpersService.getPaginator()))
        .then((response) => {
          ctrl.inventory = response.data.payload.list;
          console.log('TemplatesCreateAddonsController::getInventory', ctrl.inventory);
        })
        .catch((response) => {
          $scope.$emit('TemplatesCreateController::Error', { message: response.data.error });
        });
    },

    hasInventory: function () {
      return Array.isArray(ctrl.inventory) && ctrl.inventory.length > 0;
    },

    addInventory: function () {
      if (ctrl.selectedInventory.id && !ctrl.findAddon(ctrl.selectedInventory.id)) {
        if (!ctrl.model) {
          ctrl.model = [];
        }
        ctrl.selectedInventory.salesChannels = TemplatesService.orderSalesChannels(
          ctrl.selectedInventory.salesChannels
        );
        ctrl.model.push(angular.copy(ctrl.selectedInventory) as InventoryItem); // TODO: fix type?
        ctrl.selectedInventory = {};
      }
    },

    removeInventory: function (id: number) {
      for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
        if (ctrl.model[i].id === id) {
          ctrl.model.splice(i, 1);
          break;
        }
      }
    },

    findAddon: function (id: number) {
      if (Array.isArray(ctrl.model) && ctrl.model.length > 0) {
        for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
          if (ctrl.model[i].id === id) {
            return ctrl.model[i];
          }
        }
      }

      return false;
    },

    processSalesChannels: function () {
      for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
        ctrl.model[i].salesChannels = TemplatesService.orderSalesChannels(ctrl.model[i].salesChannels);
      }
    },

    onTemplatesCreateControllerSave: function (e, data) {
      TemplatesService.setAddOns(ctrl.model);
    },

    onTemplatesServiceUpdate: function (e, data) {
      ctrl.model = TemplatesService.getAddOns();

      // next tick
      $timeout(() => {
        ctrl.processSalesChannels();
      }, 0);
    },
  };

  $scope.templatesCreateAddons = ctrl;
  ctrl.init();
}

export const TemplatesCreateAddonsControllerModule = angular
  .module('acme.view.application.templates.create.addons.controllers', [
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.templates',
  ])
  .controller('TemplatesCreateAddonsController', TemplatesCreateAddonsController).name;
